import styled from "styled-components"
import padding from "@irati/ui/src/global/padding"
import Link from "@irati/ui/src/Link"

export const ButtonContainer = styled.div`
  margin-top: ${padding.small};
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
export const StyledLink = styled(Link)`
  display: inline !important;
`
